// extracted by mini-css-extract-plugin
module.exports = {"CustomizedXAxisTick":"CustomizedXAxisTick_CustomizedXAxisTick__lL3Fm","Small":"CustomizedXAxisTick_Small__DTK3G"};